export const compraModais = {
  comprarProduto: 'comprarProduto',
  comprarServico: 'comprarServico',
  visualizarCompra: 'visualizarCompra',
  buscaAvancada: 'buscaAvancada',
};
